const { useEffect } = require('react');
const { useSelector } = require('react-redux');
const { recordFieldVisit } = require('./recentFieldsStore');

/**
 * Records every field the user lands on, so the search can offer the last few
 * back (see recentFieldsStore).
 *
 * Watches `selected_entities.field` — the app's single notion of "the field
 * being shown" — rather than any one screen's click handler. Both the field
 * view and the Farm View dispatch it (`IrrigationSystemMonitoring.selectField`),
 * so this catches a visit however the user got there: the field list, the
 * dropdown, the map, keyboard navigation, or the search itself. Nothing else
 * has to know the feature exists.
 *
 * Mounted once, app-wide, alongside the search in GlobalSearch.jsx. Runs even
 * while the modal is closed — the modal is unmounted then, so it cannot do the
 * tracking itself.
 *
 * A field the Farm View auto-selects for the user is recorded too. It was put
 * on screen and is a plausible thing to want back, and the source of the
 * selection is not in Redux to distinguish on.
 *
 * @param {boolean} enabled - false for users outside the rollout gate, who
 *   have no search to show the list in.
 */
const useRecentFieldsTracker = (enabled = true) => {
  const selectedFieldId = useSelector(
    (state) => state.distribution_data?.selected_entities?.field?.id,
  );

  useEffect(() => {
    if (!enabled || !selectedFieldId) {
      return;
    }
    recordFieldVisit(selectedFieldId);
  }, [enabled, selectedFieldId]);
};

module.exports = useRecentFieldsTracker;
